<template>
  <div>
    <h1>Eventos de Salud</h1>
    <b-row class="mt-5 mb-5">
      <b-col cols="auto">
        <button class="button-primary" @click.prevent="newEvent()">
          <span
            >Registrar evento
            <img class="pl-1 mb-1" src="@/assets/images/icons/add.svg"
          /></span>
        </button>
      </b-col>
    </b-row>
    <b-row class="mt-5 mb-5">
      <b-col cols="12"> <TableComponent /> </b-col>
    </b-row>
  </div>
</template>

<script>
import TableComponent from "./componets/TableComponent.vue";
export default {
  name: "SaludEvent",
  components: {
    TableComponent,
  },
  methods: {
    newEvent() {
      const me = this;
      me.$router.push({
        name: "CreateEventPage",
        params: { category: "salud-event" },
      });
    },
  },
};
</script>

<style lang="css" scoped></style>
